/**
 * 40 paylines for the 5×4 variant (row index 0 = top, 3 = bottom per reel).
 * Copied from Crown Crush `Lines40` / `crownCrush40` profile so we can talk to
 * `CrownCrush40` until our own backend title exists.
 */
export const PAYLINES_40 = [
  [1, 1, 1, 1, 1], //  1
  [2, 2, 2, 2, 2], //  2
  [0, 0, 0, 0, 0], //  3
  [3, 3, 3, 3, 3], //  4
  [1, 2, 3, 2, 1], //  5
  [2, 1, 0, 1, 2], //  6
  [0, 0, 1, 2, 3], //  7
  [3, 3, 2, 1, 0], //  8
  [2, 3, 3, 3, 2], //  9
  [1, 0, 0, 0, 1], // 10
  [0, 1, 2, 3, 3], // 11
  [3, 2, 1, 0, 0], // 12
  [1, 0, 1, 2, 1], // 13
  [2, 3, 2, 1, 2], // 14
  [0, 1, 0, 1, 0], // 15
  [3, 2, 3, 2, 3], // 16
  [1, 2, 1, 0, 1], // 17
  [2, 1, 2, 3, 2], // 18
  [0, 1, 1, 1, 0], // 19
  [3, 2, 2, 2, 3], // 20
  [1, 1, 2, 3, 3], // 21
  [2, 2, 1, 0, 0], // 22
  [0, 1, 2, 2, 3], // 23
  [3, 2, 1, 1, 0], // 24
  [1, 2, 2, 2, 3], // 25
  [2, 1, 1, 1, 0], // 26
  [0, 0, 1, 0, 0], // 27
  [3, 3, 2, 3, 3], // 28
  [2, 2, 3, 2, 2], // 29
  [1, 1, 0, 1, 1], // 30
  [0, 0, 0, 1, 2], // 31
  [3, 3, 3, 2, 1], // 32
  [2, 3, 3, 2, 1], // 33
  [1, 0, 0, 1, 2], // 34
  [0, 1, 1, 2, 3], // 35
  [3, 2, 2, 1, 0], // 36
  [2, 3, 2, 1, 0], // 37
  [1, 0, 1, 2, 3], // 38
  [0, 1, 2, 3, 2], // 39
  [3, 2, 1, 0, 1], // 40
];
